var exports = {
  "$": "x31de4314--e5c7b3--media",
  "y": "x31de4314--e5c7b3--single-row",
};

module.exports = exports;
